// extracted by mini-css-extract-plugin
export var deleteModal = "_s3-0";